import { HttpRequest, TRequestOptions } from '@/service/createAxios';
import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getQueryString } from '@/utils/url';
import { isString } from 'lodash-es';
import { isFromActiveCache } from '@/utils/common';
import type { extOptionsType } from '@/types/index';

let baseApi: AxiosInstance;

export enum AxiosMethod {
  REQUEST = 'request',
  GET = 'get',
  DELETE = 'delete',
  HEAD = 'head',
  OPTIONS = 'options',
  POST = 'post',
  PUT = 'put',
  PATCH = 'patch',
  POST_FORM = 'postForm',
  PUT_FORM = 'putForm',
  PATCH_FORM = 'patchForm',
}

// more: https://www.axios-http.cn/docs/req_config
const defaultBaseApi: AxiosRequestConfig = {
  baseURL: '/',
  timeout: 60000, // 60s
  headers: {},
  params: {},
  withCredentials: true,
  responseType: 'json',
};

const methodList: string[] = Object.values(AxiosMethod);
export function createHttpRequest(options: TRequestOptions = {}, extOptions: extOptionsType = {}) {
  const instance = new HttpRequest(
    {
      ...defaultBaseApi,
      ...options,
    },
    extOptions,
  ).createInstance();
  const iProxy = new Proxy(instance, {
    get(target: AxiosInstance, key: string | symbol, proxy) {
      if (isString(key) && key in target && methodList.includes(key)) {
        switch (true) {
          case isFromActiveCache(): {
            // 来自主动缓存的访问
            return function (...args: any[]) {
              const configArg = ((args.length > 0 && args[args.length - 1]) ?? {}) as TRequestOptions; // 拿到config参数
              const { disableRequestFromActiveCache, defaultValue } = configArg;
              if (disableRequestFromActiveCache && defaultValue) {
                return Promise.resolve(defaultValue); // 修改方法，使其返回默认值
              }
              // @ts-ignore
              return Reflect.apply(target[key], target, args); // 返回原方法调用结果
            };
          }
        }
      }
      return Reflect.get(target, key, proxy);
    },
  });
  return iProxy;
}

export const useBase = (options?: TRequestOptions, extOptions: extOptionsType = {}) => {
  // 如果有定义自己的options,不能使用缓存策略
  if (options) {
    return createHttpRequest(options, extOptions);
  }
  if (!baseApi) {
    baseApi = createHttpRequest({}, extOptions);
  }
  return baseApi;
};
let httpRequest: ReturnType<typeof createHttpRequest>;
export function getHttpRequest() {
  if (!httpRequest) {
    httpRequest = createHttpRequest();
  }
  return httpRequest;
}

export const getCurrentGame = () => getQueryString('game');
